import { isLtiRoute } from './util';

export const baseUrl = process.env.REACT_APP_BACKEND_URL + '/mss/dev/';
export const ltiBaseUrl = process.env.REACT_APP_BACKEND_URL + '/mss/lti/';

// LTI requests carry a signed courseId in the JWT the backend already
// verifies, so the query param is only meaningful — and only sent — for
// dev-portal requests, which have no other trusted source for it.
const courseQuery = (courseId) =>
  courseId && !isLtiRoute() ? `?courseId=${encodeURIComponent(courseId)}` : '';

export const flashcards = ({ id, courseId } = {}) =>
  `resource/flashcard${id ? '/' + id : ''}${courseQuery(courseId)}`;
export const quizzes = ({ id, courseId } = {}) =>
  `resource/quiz${id ? '/' + id : ''}${courseQuery(courseId)}`;
export const quizSubmission = (id, courseId) =>
  `resource/quiz/${id}/submission${courseQuery(courseId)}`;
export const quizRegenerate = (id, courseId) =>
  `resource/quiz/${id}/regenerate${courseQuery(courseId)}`;
export const summaries = ({ id, courseId } = {}) =>
  `resource/summary${id ? '/' + id : ''}${courseQuery(courseId)}`;
export const modules = (courseId) => `course/modules/${courseId}`;

export const feedback = 'feedback';
// Reviewing one submission — a developer-portal route, never served over LTI.
export const feedbackItem = (id) => `feedback/${id}`;

export const users = 'impersonation/users';
export const impersonation = (midas) => `impersonation/${encodeURIComponent(midas)}`;

export const courseAnalytics = 'analytics/usage';
export const studentAnalytics = (courseId) => `analytics/usage/${encodeURIComponent(courseId)}`;
